import { Link } from "react-router-dom";
import { useState } from "react";

const LOGO_URL = "https://static.readdy.ai/image/5d9802ba43525070add1fcfd005aa0ad/5051eaabd0bbd242b70ed8ddea3511f5.png";

const footerLinks = {
  servicios: [
    { label: "Asesoría Fiscal", path: "/servicios" },
    { label: "Asesoría Laboral", path: "/servicios" },
    { label: "Seguros Empresariales", path: "/servicios" },
    { label: "Contabilidad y Finanzas", path: "/servicios" },
    { label: "Constitución de Empresas", path: "/servicios" },
  ],
  empresa: [
    { label: "Quiénes Somos", path: "/" },
    { label: "Nuestro Equipo", path: "/equipo" },
    { label: "Blog", path: "/blog" },
    { label: "Contacto", path: "/contacto" },
  ],
};

export default function Footer() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleNewsletter = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    setSubmitting(true);
    try {
      const body = new URLSearchParams({ email });
      await fetch("https://readdy.ai/api/form/d7598mf5hic0eqh31hsg", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });
      setSubmitted(true);
    } catch {
      setSubmitted(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <footer className="bg-[#1A1A1A] text-white">
      <div className="max-w-screen-xl mx-auto px-6 md:px-10 pt-16 pb-8">
        {/* Top grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-14">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-9 h-9 flex items-center justify-center">
                <img src={LOGO_URL} alt="Logo" className="w-9 h-9 object-contain" />
              </div>
              <span className="font-bold text-lg" style={{ fontFamily: "'Playfair Display', serif" }}>
                Vidal Ferrer Asesores
              </span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Más de 25 años asesorando a empresas y autónomos en materia fiscal, laboral y de seguros. Tu tranquilidad es nuestra prioridad.
            </p>
            <div className="flex items-center gap-3">
              {["ri-linkedin-fill", "ri-twitter-x-line", "ri-facebook-fill", "ri-instagram-line"].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  rel="nofollow"
                  className="w-9 h-9 flex items-center justify-center border border-white/20 rounded-full text-gray-400 hover:text-white hover:border-white/50 transition-colors cursor-pointer"
                >
                  <i className={`${icon} text-sm`} />
                </a>
              ))}
            </div>
          </div>

          {/* Servicios */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-widest text-gray-400 mb-5">Servicios</h4>
            <ul className="space-y-3">
              {footerLinks.servicios.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Empresa */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-widest text-gray-400 mb-5">Empresa</h4>
            <ul className="space-y-3">
              {footerLinks.empresa.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="mt-6 space-y-2 text-sm text-gray-400">
              <p className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-line text-[#6B7F5C]" />
                </div>
                +34 96 557 18 31 / +34 623 619 606
              </p>
              <p className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line text-[#6B7F5C]" />
                </div>
                assessoriagrevi@gmail.com
              </p>
              <p className="flex items-start gap-2">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-[#6B7F5C]" />
                </div>
                C/ Duanes, 14, Pego 03780
              </p>
            </div>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-widest text-gray-400 mb-5">Newsletter</h4>
            <p className="text-sm text-gray-400 mb-4 leading-relaxed">
              Recibe novedades fiscales y laborales en tu email cada mes.
            </p>
            {submitted ? (
              <div className="bg-[#6B7F5C]/20 border border-[#6B7F5C]/30 rounded-lg p-4 text-sm text-[#A0B08E]">
                ¡Suscripción confirmada! Gracias.
              </div>
            ) : (
              <form
                data-readdy-form
                onSubmit={handleNewsletter}
                className="flex flex-col gap-3"
              >
                <input
                  type="email"
                  name="email"
                  placeholder="tu@email.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="bg-white/10 border border-white/20 rounded-lg px-4 py-3 text-sm text-white placeholder-gray-500 focus:outline-none focus:border-[#6B7F5C] transition-colors"
                />
                <button
                  type="submit"
                  disabled={submitting}
                  className="bg-[#6B7F5C] hover:bg-[#5A6E4B] text-white text-sm font-medium py-3 rounded-lg transition-colors cursor-pointer disabled:opacity-60 whitespace-nowrap"
                >
                  {submitting ? "Suscribiendo..." : "Suscribirme"}
                </button>
              </form>
            )}
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-gray-500">
            © 2025 Vidal Ferrer Asesores. Todos los derechos reservados.
          </p>
          <div className="flex items-center gap-6">
            {["Privacidad", "Términos de Uso", "Política de Cookies"].map((item) => (
              <a
                key={item}
                href="#"
                rel="nofollow"
                className="text-xs text-gray-500 hover:text-gray-300 transition-colors cursor-pointer"
              >
                {item}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
